import { type FC } from "react";
import { Presentation } from "./Presentation";
import { type PaginationProps } from "./type";

export const Pagination: FC<PaginationProps> = ({
  currentPageNum,
  paginationData,
  maxCount, // 三点リーダーの制御のみに使用する、総ページ数の情報
  windowCount = 0, // 三点リーダーの制御のみに使用する、ページネーションを前後に表示する数の情報
}) => {
  const lastCount = paginationData.at(-1)?.pageNum;
  const nextPagePath = paginationData.find((item) => currentPageNum + 1 === item.pageNum)?.path;
  const prevPagePath = paginationData.find((item) => currentPageNum - 1 === item.pageNum)?.path;

  const isShowAfterLeader = () => {
    // 総ページ数がわかっていて、最後のページまでページネーションが表示されている場合は次ページに進むボタン横に三点リーダーを表示しない
    if (maxCount && lastCount && lastCount >= maxCount) return false;
    // 次へ進む側のページネーションの数が指定されたページネーションの表示数に満たない場合は次ページに進むボタン横に三点リーダーを表示しない
    return !(windowCount > paginationData.filter((item) => item.pageNum > currentPageNum).length);
  };

  return (
    <Presentation
      isShowAfterLeader={isShowAfterLeader()}
      currentPageNum={currentPageNum}
      paginationData={paginationData}
      nextPagePath={nextPagePath}
      prevPagePath={prevPagePath}
    />
  );
};
